import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, Observable } from 'rxjs';
import { ApplicationApiUrls } from 'src/app/constants/api-url-constants';
import { Authorize } from 'src/app/models/authorize.model';
import { ChangePasswordRequest } from 'src/app/models/request-models/change-password.request';
import { CreatUserRequest } from 'src/app/models/request-models/create-user';
import { DeleteAccountRequest, ForgotPasswordRequest } from 'src/app/models/request-models/forgot-password';
import { loginRequest } from 'src/app/models/request-models/login-request';
import { ResetPassword, ResetPasswordResponse } from 'src/app/models/request-models/reset-password-request';
import { TwoStepRequest } from 'src/app/models/request-models/two-step-request';
import { ApiResponse } from 'src/app/models/response-model/api-response';
import { UserRegestrationResponse } from 'src/app/models/response-model/user-regestration-response-model';
import { SwtichRole } from 'src/app/models/swtich-model';
import { UserProfile } from 'src/app/models/user-profile.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AccountsApiService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  login(credentials: loginRequest): Observable<ApiResponse<Authorize>> {
    return this.http.post(`${this.apiUrl}${ApplicationApiUrls.Login}`, credentials).pipe(
      map((data: ApiResponse<Authorize>) => {
        return data;
      }),
      catchError((err) => {
        throw err;
      }),
    );
  }

  googleLogin(token: string): Observable<Authorize> {
    return this.http.post(`${this.apiUrl}${ApplicationApiUrls.GoogleLogin}`, token).pipe(
      map((data: ApiResponse<Authorize>) => {
        return data.result!;
      }),
      catchError((err) => {
        throw err;
      }),
    );
  }

  appleLogin(token: string): Observable<Authorize> {
    return this.http.post(`${this.apiUrl}${ApplicationApiUrls.AppleLogin}`, token).pipe(
      map((data: ApiResponse<Authorize>) => {
        return data.result!;
      }),
      catchError((err) => {
        throw err;
      }),
    );
  }

  createUser(userData: CreatUserRequest): Observable<any> {
    return this.http.post(`${this.apiUrl}${ApplicationApiUrls.CreateUser}`, userData).pipe(
      map((data: ApiResponse<UserRegestrationResponse>) => {
        return data;
      }),
      catchError((err) => {
        throw err;
      }),
    );
  }

  GetMyProfile(): Observable<UserProfile> {
    return this.http.get(`${this.apiUrl}${ApplicationApiUrls.GetMyProfile}`).pipe(
      map((data: ApiResponse<UserProfile>) => {
        return data.result!;
      }),
      catchError((err) => {
        throw err;
      }),
    );
  }

  GetUserProfileById(userId: number): Observable<UserProfile> {
    return this.http.get(`${this.apiUrl}${ApplicationApiUrls.GetMyProfile}/${userId}`).pipe(
      map((data: any) => {

        if (data.result) {
          return data.result;
        } else if (data.data) {
          return data.data;
        } else if (data.firstName) {
          return data;
        } else {
          return data;
        }
      }),
      catchError((err) => {
        console.error('API Error Details:', {
          status: err.status,
          statusText: err.statusText,
          message: err.message,
          error: err.error,
        });
        throw err;
      }),
    );
  }

  socialAuthentication(data) {
    return this.http.post<any>(this.apiUrl + '/Auth/social-login', data);
  }

  UpdateProfile(request: UserProfile): Observable<boolean> {
    return this.http.post(`${this.apiUrl}${ApplicationApiUrls.UpdateProfile}`, request).pipe(
      map((data: ApiResponse<boolean>) => {
        return data.successful!;
      }),
      catchError((err) => {
        throw err;
      }),
    );
  }

  changePassword(request: ChangePasswordRequest): Observable<boolean> {
    return this.http.post(`${this.apiUrl}${ApplicationApiUrls.ChangeExpiredPassword}`, request).pipe(
      map((data: ApiResponse<boolean>) => {
        return data.successful!;
      }),
      catchError((err) => {
        throw err;
      }),
    );
  }

  changeProfilePic(profilePicture: File): Observable<ApiResponse<string>> {
    const formData = new FormData();
    formData.append('profilePicture', profilePicture);
    return this.http.post<ApiResponse<string>>(`${this.apiUrl}${ApplicationApiUrls.UpdateProfileImage}`, formData).pipe(
      map((response) => response),
      catchError((err) => {
        throw err;
      }),
    );
  }

  verifyOtp(request: TwoStepRequest): Observable<ApiResponse<Authorize>> {
    return this.http.post(`${this.apiUrl}${ApplicationApiUrls.TwoStepVerification}`, request).pipe(
      map((data: ApiResponse<Authorize>) => {
        return data!;
      }),
      catchError((err) => {
        throw err;
      }),
    );
  }

  resetPassword(request: ResetPassword): Observable<ApiResponse<Authorize>> {
    return this.http.post(`${this.apiUrl}${ApplicationApiUrls.ResetPassword}`, request).pipe(
      map((data: ApiResponse<Authorize>) => {
        return data;
      }),
      catchError((err) => {
        throw err;
      }),
    );
  }

  forgotPassword(request: ForgotPasswordRequest): Observable<ApiResponse<Authorize>> {
    return this.http.post(`${this.apiUrl}${ApplicationApiUrls.ForgotPassword}`, request).pipe(
      map((data: ApiResponse<Authorize>) => {
        return data!;
      }),
      catchError((err) => {
        throw err;
      }),
    );
  }

  deleteAccount(request: DeleteAccountRequest): Observable<ApiResponse<Authorize>> {
    return this.http.post(`${this.apiUrl}${ApplicationApiUrls.DeleteAccount}`, request).pipe(
      map((data: ApiResponse<Authorize>) => {
        return data!;
      }),
      catchError((err) => {
        throw err;
      }),
    );
  }

  CreateSwitchRole(request: SwtichRole): Observable<boolean> {
    return this.http.post<boolean>(`${this.apiUrl}${ApplicationApiUrls.switchRole}`, request).pipe(
      map((data) => {
        return data;
      }),
      catchError((err) => {
        throw err;
      }),
    );
  }
}
